import "./index.css";

export const PreviewExsitingKeyConditions = ({ conditionTree, keyConditionToBeOmitted, keyConditions}) => {
  return (
    <>
      {keyConditions.length > 0 ? (
        <div>
          {keyConditions.map((keyCondition, _) => {
            return (
              <div
                key={keyCondition.key}
                className="existing-key-condition"
              >
                {keyCondition.renderAsString()}
              </div>
            );
          })}
        </div>
      ) : null}
    </>
  );
};
